import { useMutation } from "@tanstack/react-query";
import commentsAPI from "../../api/comments/api";

export function useCreateComment() {
  return useMutation({
    mutationFn: commentsAPI.createComment,
    onError: (error) => {
      console.error("Create comment failed:", error);
    },
  });
}
